import React, { useState, useEffect } from "react";
import translate from "../../../i18n/translate";
import ProductCard from "../ProductCard/ProductCard";
import "./RecomendedCarouselComponent.scss";
import { useSelector } from "react-redux";

const RecomendedCarouselComponent: React.FC = () => {
  let [isNewsfeedfeatureenabled] = useState(false);
  const [isCultureNotesfeatureenabled, setCultureNotesfeatureenabled] = useState(false);
  const [isTWTfeatureenabled, setTWTfeatureenabled] = useState(false);
  const allInfo = useSelector((state: any) => state);

  const afterGetLearnerInfo = (data: any) => {
    if (data.data.getpeopleInformation.serviceConfiguration.features.substring(27, 28) === "1") {
      setCultureNotesfeatureenabled(true);
    }

    if (data.data.getpeopleInformation.serviceConfiguration.features.substring(11, 12) === "1") {
      setTWTfeatureenabled(true);
    }
  };

  useEffect(() => {
    if (
      !!!allInfo.common.isLoading &&
      !!!allInfo.peopleInformation.isLoading &&
      !!!allInfo.learnerTasks.isLoading &&
      !!!allInfo.portalLogin.isLoading &&
      !!!allInfo.jwkPublicKey.isLoading
    ) {
      if (!!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
        afterGetLearnerInfo(allInfo.peopleInformation);
      }
    }
  }, [allInfo.common, allInfo.peopleInformation, allInfo.learnerTasks, allInfo.portalLogin, allInfo.jwkPublicKey]);

  return (
    <div className="RecomendedCarouselCotainer">
      <div className="Listalign PageContainerBlock">
        <h1 className="headeralign"> {translate("title_feature")} </h1>
        <div className="featuresCardsContainer">
          {isCultureNotesfeatureenabled && (
            <ProductCard
              title={translate("feature_cultureNotes_title")}
              summary={translate("culturenotes_mainintrotext")}
              iconFontClass="string"
              headColorClass="string"
              roundButtonText="Buy Now"
              flatButtonText={translate("button_GetStarted")}
              productcardclass="recommended-card"
              cardimage="Feature_Illustrations/Culture-notes.svg"
              redirectURL={`/culturenotes`}
            />
          )}
          <ProductCard
            title={translate("feature_emailTemplates_title")}
            summary={translate("Blob")}
            iconFontClass="string"
            headColorClass="coach"
            roundButtonText="Buy Now"
            flatButtonText={translate("button_GetStarted")}
            productcardclass="recommended-card"
            cardimage="Feature_Illustrations/Email-templates.svg"
            redirectURL={`/emailtemplates`}
          />

          {isTWTfeatureenabled && (
            <ProductCard
              title={translate("feature_talkWithTeacher_title")}
              summary={translate("feature_talkWithTeacher_desc")}
              iconFontClass="string"
              headColorClass="coach"
              roundButtonText="Buy Now"
              flatButtonText={translate("button_view")}
              productcardclass="recommended-card"
              cardimage="Feature_Illustrations/Talk-with-a-teacher.svg"
              redirectURL={`/twt`}
            />
          )}

          {isNewsfeedfeatureenabled && (
            <ProductCard
              title={translate("dailyNewsFeed_newsfeedoftheday")}
              summary={translate("feature_newsFeed_desc")}
              iconFontClass="string"
              headColorClass="virtual"
              roundButtonText="Buy Now"
              flatButtonText={translate("button_GetStarted")}
              productcardclass="recommended-card"
              cardimage="Feature_Illustrations/News-feed.svg"
              redirectURL={`${window.location.protocol}//newsfeed.globalenglish.com`}
            />
          )}

          {/* <ProductCard
              title={translate("feature_industryfeed_title")}
              summary={translate("feature_industryFeed_desc")}
              iconFontClass="string"
              headColorClass="string"
              roundButtonText="Buy Now"
              flatButtonText={translate("button_GetStarted")}
              productcardclass="recommended-card"
              cardimage="Feature_Illustrations/Industry-feed.svg"
              redirectURL={`/industryfeed`}
            /> */}

          <ProductCard
            title={translate("accentsAndDialects_heading")}
            summary={translate("feature_accentsAndDialects_desc")}
            iconFontClass="string"
            headColorClass="string"
            roundButtonText="Buy Now"
            flatButtonText={translate("button_GetStarted")}
            productcardclass="recommended-card"
            cardimage="Feature_Illustrations/Accents-and-dialects.svg"
            redirectURL={`/accentsanddialects`}
          />
          <ProductCard
            title={translate("vocab_center_product_headline")}
            summary={translate("vocab_center_feature_text")}
            iconFontClass="string"
            headColorClass="string"
            roundButtonText="Buy Now"
            flatButtonText={translate("button_GetStarted")}
            productcardclass="recommended-card"
            cardimage="Feature_Illustrations/Vocabulary-center.svg"
            redirectURL={`/vocabularycenter`}
          />
        </div>
      </div>
    </div>
  );
};

export default RecomendedCarouselComponent;
